import { render, staticRenderFns } from "./downPrice.vue?vue&type=template&id=56cbc0f8&scoped=true&"
import script from "./downPrice.vue?vue&type=script&lang=js&"
export * from "./downPrice.vue?vue&type=script&lang=js&"
import style0 from "./downPrice.vue?vue&type=style&index=0&id=56cbc0f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cbc0f8",
  null
  
)

export default component.exports